import React from 'react';
import { createRoot } from 'react-dom/client';
import { PropertyAvailabilityCalendar } from '../../_shared/PropertyAvailabilityCalendar';

interface PropertyAvailabilityData {
	listingId: number;
	ajaxUrl: string;
}

declare global {
	interface Window {
		propertyAvailabilityData?: PropertyAvailabilityData;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll<HTMLElement>('.wp-block-ocean-property-availability');
	
	containers.forEach((container) => {
		const listingId = parseInt(container.dataset.listingId || '0', 10);
		const ajaxUrl = container.dataset.ajaxUrl || '';
		const bookingUrl = container.dataset.bookingUrl || '';
		const showPrices = container.dataset.showPrices === '1';

		if (!listingId || !ajaxUrl) return;

		const root = createRoot(container);
		root.render(
			<PropertyAvailabilityCalendar
				listingId={listingId}
				ajaxUrl={ajaxUrl}
				bookingUrl={bookingUrl}
				showPrices={showPrices}
			/>
		);
	});
});
